import { TIME_RANGE } from '~services/constant/common';

//  拜访记录用户角色搜索下拉框
const visitSearchSelectTypes = ['销售人员', '非销售人员'];

export const VISIT_SEARCH_SELECT_OPTIONS = visitSearchSelectTypes.map(
  (label, index) => ({
    label,
    value: index + 1,
  }),
);

//  拜访记录用户角色搜索下拉框
export const GET_VISIT_OBJECT_SELECT_TYPES = [
  {
    label: '客户',
    value: 1,
  },
  {
    label: '商机',
    value: 2,
  },
  {
    label: '线索',
    value: 3,
  },
];
